/*
 * Copyright (C) 2026 Zyla Health Pvt Ltd. All rights reserved.
 *
 * Shared normalization for inclusion/exclusion candidate labels so the "Add
 * category" flow dedupes the same way the client-config backend does
 * (normalizeCandidates in planServiceCategoryRepo.go): trim + collapse internal
 * whitespace, and compare case-insensitively.
 */

// Clean a label for storage/display: trim ends and collapse internal whitespace.
export const normalizeLabel = (s) => (s || "").trim().replace(/\s+/g, " ");

// Case-insensitive key for duplicate comparisons.
export const labelKey = (s) => normalizeLabel(s).toLowerCase();

// Whether two labels are the same once normalized (case-insensitive).
export const sameLabel = (a, b) => labelKey(a) === labelKey(b);
